import {
  useGetFieldLabel,
  useGetFieldPlaceholder,
} from "../../contexts/LanguageContext";
import { TApplicationField } from "../../hooks/application-fields.hooks";
import { TDocumentConfig } from "../../hooks/forms.hooks";
import { Dialog, DialogProps } from "../CommonComponents/Dialog/Dialog";
import Input from "../CommonComponents/Input/Input";

type PreviewDialogProps = DialogProps & {
  selectedDocuments: TDocumentConfig[];
  selectedFields: TApplicationField[];
};

export default function PreviewDialog({
  selectedDocuments,
  selectedFields,
  ...rest
}: PreviewDialogProps) {
  const convertPlaceholder = useGetFieldPlaceholder();
  const convert = useGetFieldLabel();
  return (
    <Dialog
      {...rest}
      className="flex flex-col p-3 min-w-[260px] sm:min-w-[600px] lg:min-w-[800px]"
    >
      <div className="flex justify-center items-center shrink-0 mb-3 p-3">
        <h4 className="m-0 grow text-center text-2xl font-bold">Preview</h4>
        <button className="text-xl" onClick={rest.onClose}>
          <i className="fa fa-close m-0"></i>
        </button>
      </div>
      <div className="grow overflow-auto p-3">
        <div className="grid grid-cols-2 auto-rows-auto gap-8">
          {selectedFields.map((e, i) => (
            <Input
              disabled
              label={convert(e)}
              placeholder={convertPlaceholder(e)}
              containerClass="col-span-2 md:col-span-1"
            />
          ))}
          {selectedDocuments.map((e) => (
            <div className="flex space-x-4 items-center col-span-2">
              <p className="grow text-grey-600">
                {e.document_label}
                {e.mandatory ? <span className="text-red-500">*</span> : null}
              </p>
              <Input placeholder="Choose File" disabled containerClass="w-64" />
              <button>
                <i className="text-xl fa fa-eye"></i>
              </button>
              <button>
                <i className="text-xl fa fa-trash-o"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </Dialog>
  );
}
